import React from 'react'
import { withCounter } from '../../hocs'

const ClickCounter = ({ incrementCount, count, name }) => (
  <button onClick={incrementCount}>
    {name} clicked {count} times
  </button>
)

export default withCounter(ClickCounter, 1)
